"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConditionEvaluationError = void 0;
/**
 * Custom error class for condition evaluation failures
 */
class ConditionEvaluationError extends Error {
    constructor(message, conditionScript, optionId, playerId, cause) {
        super(message);
        this.conditionScript = conditionScript;
        this.optionId = optionId;
        this.playerId = playerId;
        this.cause = cause;
        this.name = 'ConditionEvaluationError';
        // Maintains proper stack trace for where our error was thrown (only works on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ConditionEvaluationError);
        }
    }
}
exports.ConditionEvaluationError = ConditionEvaluationError;
//# sourceMappingURL=ConditionEvaluationError.js.map